import { render } from "./ProjekteList.vue?vue&type=template&id=264ba804"
import script from "./ProjekteList.vue?vue&type=script&lang=js"
export * from "./ProjekteList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__